import axios from "axios";

const api = axios.create({
  baseURL: "https://ramukaknewbackend-a08t.onrender.com",
  timeout: 10000,
});

// Automatically attach token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
